<template>
<w-panel>
  <div slot="header-tool-left" class="title-h3">연결장비 정보</div>
  <div slot="header-tool-right">
    최근 수집시간 : <em>{{netDeviceInfo.arpCheckDatetime}}</em>
    진행상태 : <em>{{netDeviceInfo.arpCheckStatus}}</em>
    <el-button size="small" @click="checkArpStatus()" type="primary" class="mr-l15">연결장비 정보 갱신</el-button>
    <el-button size="small" @click="exportInterfaceArpInfo()"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
    <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
  </div>
  <el-row slot="body">
    <el-col :span="24">
      <el-table-wrapper :data="dataList" :columns="connDeviceColumns" :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
      </el-table-wrapper>
    </el-col>
  </el-row>
</w-panel>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { isNil, eq } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';

export default {
  name: 'WInterfaceConnectDeviceNode',
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      showSearchTool: false,
      dataList: null,
      netDeviceInfo: {
        objId: null,
        arpCheckDatetime: null,
        arpCheckStatus: null,
      },
      params: {
        objId: null,
      },
      columnDefault,
      connDeviceColumns: [
        {
          prop: 'nodeName',
          label: '장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'arpIpaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'arpMacaddress',
          label: 'MAC 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'driverName',
          label: 'NIC 제조사',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
    },
    nodeParams: {
      handler() {
        this.params.objId = this.nodeParams.objId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    exportInterfaceArpInfo() {
      netdeviceInfoAPI.exportInterfaceArpInfoList(this.nodeParams.objId);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [executeScanArp ]
     * @author yelim
     * @return {[type]}
     */
    executeScanArp() {
      netdeviceInfoAPI.getNetdevice({ netdeviceId: this.nodeParams.netdeviceId }).then((result) => {
        const resultData = result.data.data;
        if (!isNil(resultData.arpCheckStatus)) {
          if (!eq(resultData.arpCheckStatus, 'P')) {
            netdeviceInfoAPI.setArpScan({ objId: this.netDeviceInfo.objId }).then((response) => {
              if (response.data.success) {
                this.getConnDeviceList();
              }
            }).then(() => {
              if (!isNil(resultData.arpCheckStatus)) {
                if (eq(resultData.arpCheckStatus, 'I')) {
                  this.netDeviceInfo.arpCheckStatus = '신규장비';
                } else if (eq(resultData.arpCheckStatus, 'P')) {
                  this.netDeviceInfo.arpCheckStatus = '수행중';
                } else if (eq(resultData.arpCheckStatus, 'S')) {
                  this.netDeviceInfo.arpCheckStatus = '성공';
                } else if (eq(resultData.arpCheckStatus, 'F')) {
                  this.netDeviceInfo.arpCheckStatus = '실패';
                }
              }
              if (!isNil(resultData.arpCheckDatetime)) {
                this.netDeviceInfo.arpCheckDatetime = getDateToString(resultData.arpCheckDatetime);
              }
            });
          }
        }
      });
    },
    checkArpStatus() {
      const me = this;
      netdeviceInfoAPI.getManagetype({ managetypeId: 'NMS' }).then((result) => {
        if (result.data.data.activeAgentManagerFlag === '1') {
          me.executeScanArp();
        }
      });
    },
    getConnDeviceList() {
      netdeviceInfoAPI.getInterfaceArp(this.params).then((result) => {
        this.dataList = result.data.data;
      });
    },
    loadStore() {
      if (!isNil(this.params) && this.activeTab === this.$options.name) {
        this.getConnDeviceList();
        netdeviceInfoAPI.getNetdevice({ netdeviceId: this.nodeParams.netdeviceId }).then((result) => {
          const resultData = result.data.data;
          this.netDeviceInfo.objId = resultData.objId;
          if (!isNil(resultData.arpCheckStatus)) {
            if (eq(resultData.arpCheckStatus, 'I')) {
              this.netDeviceInfo.arpCheckStatus = '신규장비';
            } else if (eq(resultData.arpCheckStatus, 'P')) {
              this.netDeviceInfo.arpCheckStatus = '수행중';
            } else if (eq(resultData.arpCheckStatus, 'S')) {
              this.netDeviceInfo.arpCheckStatus = '성공';
            } else if (eq(resultData.arpCheckStatus, 'F')) {
              this.netDeviceInfo.arpCheckStatus = '실패';
            }
          }
          if (!isNil(resultData.arpCheckDatetime)) {
            this.netDeviceInfo.arpCheckDatetime = getDateToString(resultData.arpCheckDatetime);
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netinterface/connectdevice/index.vue